import { Dispatch } from 'redux';
import { IStore } from '../models/store';
import { IReduxContext } from '../redux/store';

export interface INewbuildingSuggestion {
  Info: string;
  Url: string;
  LocationId: number;
  Name: string;
  Address: string;
  Lat: string;
  Lng: string;
  Type: 1 | 2;
  Id: number;
  Value: string;
}

export interface IGetNewbuildingsSearchSuggestions {
  (text: string, region: number | undefined):
    (dispatch: Dispatch<any>, getState: () => IStore, context: IReduxContext) => Promise<INewbuildingSuggestion[]>;
}

export const getNewbuildingsSearchSuggestions: IGetNewbuildingsSearchSuggestions = (text, region) => {
  return (dispatch, getState, context) => {
    const regionParam = region ? `r=${Math.abs(region)}&` : '';

    return context.makeRequest({
      method: 'GET',
      uri: {
        path: `/ajax/jk/search-autocomplete/?${regionParam}q=${encodeURIComponent(text)}`,
      },
    })
    .then((response: { suggestions: [{ data: INewbuildingSuggestion }] }) => {
      return response.suggestions.map(suggestion => suggestion.data);
    })
    .catch(error => {
      console.error(error);

      return Promise.resolve([]);
    });
  };
};
